<div class="w-full">
    <div class="3xl:grid-cols-4 grid-flow-col-2 grid gap-8 gap-y-8 xl:grid-cols-2 2xl:grid-cols-3">
        @for (i of numberOfShimmerCards(); track i) {
            <div
                class="animate max-h-87.5 min-h-87.5 max-w-90 min-w-90 place-self-center rounded-lg lg:max-h-91 lg:min-h-91 lg:max-w-87 lg:min-w-87"
            ></div>
        }
    </div>
</div>
